import { Task } from "app/entities/Task";
import {AppFile} from './AppFile';

export class CreateTaskWithFiles {
  TaskToCreate: Task;
  Files: AppFile[];
}



// WEBPACK FOOTER //
// C:/Projects/ePlanner Maintenance/src/app/entities/CreateTaskWithFiles.ts